import { render, staticRenderFns } from "./Saviour.vue?vue&type=template&id=4703a35e&scoped=true&"
import script from "./Saviour.vue?vue&type=script&lang=js&"
export * from "./Saviour.vue?vue&type=script&lang=js&"
import style0 from "./Saviour.vue?vue&type=style&index=0&id=4703a35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4703a35e",
  null
  
)

export default component.exports